import { render, staticRenderFns } from "./DepositForArgentinaModal.vue?vue&type=template&id=9cfeed10&scoped=true"
import script from "./DepositForArgentinaModal.vue?vue&type=script&lang=js"
export * from "./DepositForArgentinaModal.vue?vue&type=script&lang=js"
import style0 from "./DepositForArgentinaModal.vue?vue&type=style&index=0&id=9cfeed10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfeed10",
  null
  
)

export default component.exports